import React from 'react';
import { IIconProps } from '../interfaces';
const VerifiedIcon = (props: IIconProps) => {

  return (
      <svg width={ props.width } height={ props.height } viewBox="0 0 14 14"  xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="6.8929" cy="7.09771" rx="5.88802" ry="5.89068" fill="#3452FF" stroke="#3452FF" strokeWidth="0.866675"/>
          <path fillRule="evenodd" clipRule="evenodd" d="M9.56093 5.35942C9.47643 5.36212 9.39612 5.39636 9.33682 5.45493L6.33566 8.35497L4.8257 6.89394C4.76501 6.83402 4.6819 6.79933 4.59459 6.79888C4.50728 6.79797 4.4237 6.83131 4.36208 6.89078C4.30045 6.9498 4.26589 7.03044 4.26636 7.11469C4.26683 7.19894 4.30185 7.27913 4.36441 7.33815L6.10494 9.02224C6.1661 9.08126 6.24874 9.1146 6.33558 9.1146C6.42196 9.1146 6.50507 9.08126 6.56623 9.02224L9.79808 5.89925C9.89426 5.8087 9.92321 5.67039 9.87091 5.551C9.81815 5.43161 9.69535 5.35548 9.56089 5.35953L9.56093 5.35942Z" fill="white" stroke="white" strokeWidth="0.44828"/>
      </svg>

  )
};

export default VerifiedIcon;